$w.onReady(function () {
// Footer Copyright Date - Velo masterPage,js Template by Great Lakes Multimedia //
    const year = new Date().getFullYear();
    $w('#footerCopyright').text = `© ${year} by Beneath The Surface. All rights reserved.`;
});